// extracted by mini-css-extract-plugin
export var contentSection = "_f-8";
export var imageSection = "_f-1";
export var productGrid = "_f-0";
export var productImage = "_f-3";
export var productImageContainer = "_f-2";
export var productInfo = "_f-9";
export var purchaseControls = "_f-a";
export var quantityInput = "_f-c";
export var selectedThumbnail = "_f-6";
export var thumbnailContainer = "_f-4";
export var thumbnailImage = "_f-7";
export var thumbnailItem = "_f-5";
export var variantSelect = "_f-b";